import { LitElement, html, svg } from 'lit';

export class IconNoSmoking32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Overstreket sigarett</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M24.667 12.333H29a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H16.73M7 20.333H5v-8h9.916M1 12.333v8M1 31 31 1M1 7a2 2 0 0 1 2-2 4 4 0 0 0 4-3.969"></path></svg>`; }
}
if (!customElements.get('f-icon-no-smoking32', IconNoSmoking32)) {
  customElements.define('f-icon-no-smoking32', IconNoSmoking32);
}